(function () {
  // Página real /cart (sections/main-cart.liquid). Archivo propio y acotado
  // a propósito — no se agrega a theme.js (ya tiene +1200 líneas). Cubre
  // cosas independientes de esta página: cantidad/eliminar de ítems, el
  // formulario "Solicitar factura", el RUT de boleta y el código de descuento.

  const STORAGE_KEY = 'benis_invoice_data';
  const FIELD_NAMES = ['rut', 'razon_social', 'giro', 'direccion', 'comuna', 'ciudad'];

  // ===== Cantidad / eliminar =====
  // Mismo patrón de data-key/data-qty que ya usa el drawer, pero el refresco
  // acá es simple: recargar la página completa (a diferencia del drawer, que
  // usa la Section Rendering API para no perder el estado del modal).

  function initCartPageItems() {
    const list = document.querySelector('.cart-page__items');
    if (!list || list.dataset.initialized === 'true') return;
    list.dataset.initialized = 'true';

    list.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-qty-decrease], [data-qty-increase], [data-key][data-qty="0"]');
      if (!btn) return;

      const key = btn.dataset.key;
      const qty = parseInt(btn.dataset.qty, 10);
      if (!key || Number.isNaN(qty)) return;

      btn.disabled = true;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        window.location.reload();
      } catch (err) {
        console.error('Cart page quantity update error:', err);
        btn.disabled = false;
      }
    });
  }

  // ===== Carrusel "También te puede interesar" =====
  // snippets/cart-page-carousel.liquid. Agregar recarga la página (mismo
  // patrón que +/- de arriba) en vez de abrir el drawer (a diferencia del
  // data-atc genérico de theme.js) — data-cart-page-add es un atributo
  // propio a propósito, para no disparar los dos handlers a la vez sobre
  // el mismo click.

  function initProductCarouselAtc() {
    const track = document.querySelector('[data-cart-carousel]');
    if (!track || track.dataset.atcInitialized === 'true') return;
    track.dataset.atcInitialized = 'true';

    track.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-page-add][data-variant-id]');
      if (!btn || btn.disabled) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      const label = btn.querySelector('[data-cart-page-add-label]');
      const original = label ? label.textContent : btn.textContent;
      if (label) label.textContent = 'Agregando…';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        window.location.reload();
      } catch (err) {
        console.error('Cart page carousel add error:', err);
        btn.disabled = false;
        if (label) label.textContent = original;
      }
    });
  }

  // ===== Lista de ítems con scroll propio (desktop) =====
  // theme.css limita el alto de .cart-page__items en desktop. Acá: (1) la
  // clase .has-more pone un degradado abajo mientras queden ítems por ver, y
  // (2) como +/- y eliminar recargan la página, se guarda la posición del
  // scroll al salir y se restaura SOLO si fue una recarga (volver a /cart
  // desde otra página arranca arriba).

  const ITEMS_SCROLL_KEY = 'benis_cart_items_scroll';

  function initCartItemsScroll() {
    const list = document.querySelector('[data-cart-items-scroll]');
    if (!list || list.dataset.scrollInitialized === 'true') return;
    list.dataset.scrollInitialized = 'true';

    try {
      const nav = performance.getEntriesByType('navigation')[0];
      const saved = window.sessionStorage.getItem(ITEMS_SCROLL_KEY);
      window.sessionStorage.removeItem(ITEMS_SCROLL_KEY);
      if (saved && nav && nav.type === 'reload') list.scrollTop = parseInt(saved, 10) || 0;
    } catch (err) {
      // sin sessionStorage la lista simplemente arranca arriba
    }

    function updateFade() {
      const remaining = list.scrollHeight - list.clientHeight - list.scrollTop;
      list.classList.toggle('has-more', remaining > 4);
    }

    list.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);
    window.addEventListener('pagehide', () => {
      try {
        window.sessionStorage.setItem(ITEMS_SCROLL_KEY, String(Math.round(list.scrollTop)));
      } catch (err) {
        // ignore storage errors
      }
    });
    updateFade();
  }

  // ===== Carrusel "También te puede interesar": arrastre + infinito + autoplay =====
  // Arrastre con mouse igual que assets/loyaliu-account-page.js
  // (initTabsCarousel): umbral de 6px antes de contarlo como arrastre real y
  // touch nativo del navegador.
  //
  // Si las tarjetas no caben en el ancho disponible, el carrusel pasa a modo
  // infinito: se duplica el set de tarjetas una vez (copias con aria-hidden y
  // sin foco de teclado, pero con "Agregar" funcionando por delegación) y la
  // posición se maneja en `pos`, siempre dentro de [0, loopWidth) — como las
  // copias son idénticas, saltar loopWidth no se nota. Todo movimiento
  // (autoplay, flechas, arrastre) pasa por `pos` en un solo loop de
  // requestAnimationFrame, así nunca se llega a un borde.
  //
  // Autoplay: avanza solo y se frena mientras el mouse está encima, mientras
  // se toca/arrastra o hay foco dentro; retoma CAROUSEL_RESUME_DELAY después
  // de soltar. Sin autoplay con prefers-reduced-motion (las flechas siguen
  // siendo infinitas). Si las tarjetas caben, nada de esto: carrusel quieto
  // con flechas que se esconden en cada punta, como antes.

  const CAROUSEL_SPEED = 28; // px por segundo
  const CAROUSEL_RESUME_DELAY = 2500;
  const CAROUSEL_ARROW_DURATION = 450;

  function initProductCarouselDrag() {
    const track = document.querySelector('[data-cart-carousel]');
    const wrap = track ? track.closest('.cart-page__carousel-wrap') : null;
    const prevBtn = document.querySelector('[data-cart-carousel-prev]');
    const nextBtn = document.querySelector('[data-cart-carousel-next]');
    if (!track || track.dataset.dragInitialized === 'true') return;
    track.dataset.dragInitialized = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const originals = Array.from(track.children);

    let isLooping = false;
    let loopWidth = 0;
    let pos = 0;
    let lastRendered = -1;
    let anim = null;
    let hovering = false;
    let interacting = false;
    let focusInside = false;
    let pausedUntil = 0;
    let inView = true;
    let lastTs = 0;
    let rafId = 0;

    function mod(value) {
      return ((value % loopWidth) + loopWidth) % loopWidth;
    }

    function render() {
      track.scrollLeft = pos;
      lastRendered = track.scrollLeft;
    }

    function removeClones() {
      track.querySelectorAll('[data-carousel-clone]').forEach((clone) => clone.remove());
    }

    function addClones() {
      originals.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.dataset.carouselClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
      });
    }

    function measureLoop() {
      const firstClone = track.querySelector('[data-carousel-clone]');
      loopWidth = firstClone ? firstClone.offsetLeft - originals[0].offsetLeft : 0;
    }

    // Decide el modo según si el set original cabe o no en el ancho actual.
    function setupMode() {
      removeClones();
      const overflows = originals.length > 1 && track.scrollWidth > track.clientWidth + 4;

      if (overflows) {
        addClones();
        measureLoop();
        isLooping = loopWidth > 0;
      } else {
        isLooping = false;
      }

      if (isLooping) {
        pos = mod(track.scrollLeft);
        render();
        if (prevBtn) prevBtn.hidden = false;
        if (nextBtn) nextBtn.hidden = false;
        if (!rafId) rafId = window.requestAnimationFrame(tick);
      } else {
        if (rafId) window.cancelAnimationFrame(rafId);
        rafId = 0;
        updateArrows();
      }
    }

    function updateArrows() {
      if (isLooping) return;
      const max = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.hidden = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.hidden = track.scrollLeft >= max - 4;
    }

    function canAutoplay() {
      return !reduceMotion && inView && !document.hidden && !hovering && !interacting
        && !focusInside && !anim && Date.now() >= pausedUntil;
    }

    function tick(ts) {
      const dt = lastTs ? Math.min((ts - lastTs) / 1000, 0.1) : 0;
      lastTs = ts;

      if (isLooping) {
        if (anim) {
          const t = Math.min((ts - (anim.start || ts)) / CAROUSEL_ARROW_DURATION, 1);
          if (!anim.start) anim.start = ts;
          const eased = 1 - Math.pow(1 - t, 3);
          pos = mod(anim.from + anim.delta * eased);
          render();
          if (t >= 1) anim = null;
        } else if (canAutoplay()) {
          pos = mod(pos + CAROUSEL_SPEED * dt);
          render();
        }
      }

      rafId = window.requestAnimationFrame(tick);
    }

    function pauseFor(ms) {
      pausedUntil = Math.max(pausedUntil, Date.now() + ms);
    }

    function step(direction) {
      const delta = direction * track.clientWidth * 0.7;
      if (isLooping) {
        anim = { from: pos, delta, start: 0 };
        pauseFor(CAROUSEL_RESUME_DELAY);
      } else {
        track.scrollBy({ left: delta, behavior: 'smooth' });
      }
    }

    prevBtn?.addEventListener('click', () => step(-1));
    nextBtn?.addEventListener('click', () => step(1));

    // Scroll nativo (touch, trackpad): se adopta como nueva posición y, en
    // modo infinito, se envuelve si pasó del primer set.
    track.addEventListener('scroll', () => {
      if (!isLooping) {
        updateArrows();
        return;
      }
      if (Math.abs(track.scrollLeft - lastRendered) < 1) return;
      pos = mod(track.scrollLeft);
      if (track.scrollLeft >= loopWidth) render();
      else lastRendered = track.scrollLeft;
      pauseFor(CAROUSEL_RESUME_DELAY);
    }, { passive: true });

    // Pausas del autoplay: mouse encima, toque, foco de teclado.
    wrap?.addEventListener('mouseenter', () => { hovering = true; });
    wrap?.addEventListener('mouseleave', () => {
      hovering = false;
      pauseFor(800);
    });
    track.addEventListener('touchstart', () => { interacting = true; }, { passive: true });
    track.addEventListener('touchend', () => {
      interacting = false;
      pauseFor(CAROUSEL_RESUME_DELAY);
    }, { passive: true });
    track.addEventListener('touchcancel', () => { interacting = false; }, { passive: true });
    wrap?.addEventListener('focusin', () => { focusInside = true; });
    wrap?.addEventListener('focusout', () => { focusInside = false; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
      }).observe(track);
    }

    let isDown = false;
    let didDrag = false;
    let startX = 0;
    let startScroll = 0;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      didDrag = false;
      interacting = true;
      anim = null;
      startX = e.pageX;
      startScroll = isLooping ? pos : track.scrollLeft;
      track.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const delta = e.pageX - startX;
      if (Math.abs(delta) > 6) didDrag = true;
      if (isLooping) {
        pos = mod(startScroll - delta);
        render();
      } else {
        track.scrollLeft = startScroll - delta;
      }
    });

    function stopDragging() {
      isDown = false;
      interacting = false;
      pauseFor(CAROUSEL_RESUME_DELAY);
      track.classList.remove('is-dragging');
    }
    window.addEventListener('mouseup', () => { if (isDown) stopDragging(); });
    track.addEventListener('mouseleave', () => { if (isDown) stopDragging(); });

    // Si hubo arrastre real, cancela el click (evita que "arrastrar hasta
    // soltar sobre una tarjeta" dispare el link de esa tarjeta sin querer).
    track.addEventListener('click', (e) => {
      if (didDrag) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);

    let resizeTimer = 0;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(setupMode, 200);
    });

    setupMode();
  }

  // ===== Solicitar factura =====

  function cleanRut(rut) {
    return (rut || '').replace(/[^0-9kK]/g, '').toUpperCase();
  }

  // Formato que lee Pivot/Kame para la Boleta: sin puntos, con guion y K
  // mayúscula (ej. "12.345.678-k" → "12345678-K"). Solo se aplica a un RUT
  // ya validado, así que siempre hay al menos cuerpo + dígito verificador.
  function normalizeRut(rut) {
    const clean = cleanRut(rut);
    return `${clean.slice(0, -1)}-${clean.slice(-1)}`;
  }

  function isValidRut(rut) {
    const clean = cleanRut(rut);
    if (clean.length < 2) return false;
    const body = clean.slice(0, -1);
    const dv = clean.slice(-1);
    if (!/^\d+$/.test(body)) return false;

    let sum = 0;
    let multiplier = 2;
    for (let i = body.length - 1; i >= 0; i--) {
      sum += parseInt(body[i], 10) * multiplier;
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }
    const remainder = 11 - (sum % 11);
    const expectedDv = remainder === 11 ? '0' : remainder === 10 ? 'K' : String(remainder);
    return dv === expectedDv;
  }

  function initInvoiceForm() {
    const form = document.querySelector('[data-invoice-form]');
    if (!form || form.dataset.initialized === 'true') return;
    form.dataset.initialized = 'true';

    const toggle = form.querySelector('[data-invoice-toggle]');
    const fieldsWrap = form.querySelector('[data-invoice-fields]');
    const saveBtn = form.querySelector('[data-invoice-save]');
    const status = form.querySelector('[data-invoice-status]');
    const inputs = {};
    FIELD_NAMES.forEach((name) => {
      inputs[name] = form.querySelector(`[data-invoice-field="${name}"]`);
    });

    const touched = new Set();

    restoreFromLocalStorage();
    validateForm();

    toggle.addEventListener('change', async () => {
      fieldsWrap.hidden = !toggle.checked;
      if (toggle.checked) {
        validateForm();
        return;
      }
      // Se destildó: limpiar attributes si había una factura guardada antes.
      status.textContent = '';
      try {
        await saveInvoiceAttributes({ clear: true });
      } catch (err) {
        console.error('Invoice attributes clear error:', err);
      }
    });

    FIELD_NAMES.forEach((name) => {
      inputs[name]?.addEventListener('input', () => {
        clearFieldError(name);
        validateForm();
      });
      inputs[name]?.addEventListener('blur', () => {
        touched.add(name);
        validateForm();
      });
    });

    saveBtn.addEventListener('click', async () => {
      FIELD_NAMES.forEach((name) => touched.add(name));
      if (!validateForm()) return;
      saveBtn.disabled = true;
      const original = saveBtn.textContent;
      saveBtn.textContent = 'Guardando…';
      try {
        await saveInvoiceAttributes({ clear: false });
        status.textContent = 'Datos de factura guardados ✓';
        persistToLocalStorage();
      } catch (err) {
        console.error('Invoice attributes save error:', err);
        status.textContent = 'No se pudo guardar, inténtalo de nuevo.';
      } finally {
        saveBtn.disabled = false;
        saveBtn.textContent = original;
      }
    });

    function fieldValue(name) {
      return (inputs[name]?.value || '').trim();
    }

    function clearFieldError(name) {
      const error = form.querySelector(`[data-invoice-error="${name}"]`);
      if (error) error.hidden = true;
    }

    function validateForm() {
      if (!toggle.checked) {
        saveBtn.disabled = true;
        return false;
      }

      let allValid = true;
      FIELD_NAMES.forEach((name) => {
        const value = fieldValue(name);
        const error = form.querySelector(`[data-invoice-error="${name}"]`);
        const isEmpty = value === '';
        const isBadRut = name === 'rut' && !isEmpty && !isValidRut(value);
        // El campo requerido solo se marca en rojo después de que el
        // visitante lo tocó (blur) o intentó guardar — mostrar "Completa X"
        // apenas se tilda "Solicitar factura", antes de escribir nada, sería
        // ruido. El RUT inválido sí se muestra apenas se escribe algo malo,
        // sin esperar a touched (ya tiene contenido que revisar).
        const showEmptyError = isEmpty && touched.has(name);

        if (error) error.hidden = !(showEmptyError || isBadRut);
        if (isEmpty || isBadRut) allValid = false;
      });

      saveBtn.disabled = !allValid;
      return allValid;
    }

    async function saveInvoiceAttributes({ clear }) {
      const attributes = { requiere_factura: clear ? 'false' : 'true' };
      FIELD_NAMES.forEach((name) => {
        attributes[`factura_${name}`] = clear ? '' : fieldValue(name);
      });

      await window.BenisCart.updateAttributes(attributes);
    }

    function persistToLocalStorage() {
      try {
        const data = {};
        FIELD_NAMES.forEach((name) => { data[name] = fieldValue(name); });
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (err) {
        // ignore storage errors (private mode, quota, etc.)
      }
    }

    function restoreFromLocalStorage() {
      // Solo prellena campos vacíos — nunca pisa un valor que ya vino
      // prellenado desde cart.attributes (Liquid, ver invoice-request-form.liquid).
      try {
        const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
        if (!saved) return;
        FIELD_NAMES.forEach((name) => {
          if (inputs[name] && !inputs[name].value && saved[name]) {
            inputs[name].value = saved[name];
          }
        });
      } catch (err) {
        // ignore malformed storage
      }
    }
  }

  // ===== RUT opcional para boleta (sin factura) =====
  // Aparte del formulario de factura a propósito — ver
  // snippets/boleta-rut-form.liquid. Reusa cleanRut/isValidRut de arriba,
  // no las duplica. Sin botón "Guardar": se guarda solo al salir del campo
  // (blur) si está vacío o es válido; si es inválido, muestra el error y
  // no guarda nada — nunca bloquea nada más de la página.
  //
  // Event delegation a propósito (document.addEventListener, no listeners
  // por elemento como en initInvoiceForm): este campo vive tanto en /cart
  // como dentro del cart drawer (snippets/cart-drawer.liquid), y el drawer
  // se reemplaza entero (innerHTML) en cada cambio de carrito vía
  // refreshCartDrawer() en theme.js — un listener atado al elemento viejo
  // quedaría huérfano después del primer +/-. Delegar en `document` (que
  // nunca se destruye) evita tener que reinicializar nada después de cada
  // refresh, y de paso soporta que existan dos instancias del campo al
  // mismo tiempo (/cart y el drawer abierto sobre esa misma página) sin
  // pisarse — cada handler opera solo sobre el contenedor más cercano al
  // elemento que disparó el evento, closest('[data-boleta-rut-form]').

  function initBoletaRutForm() {
    if (initBoletaRutForm.bound) return;
    initBoletaRutForm.bound = true;

    document.addEventListener('input', (e) => {
      const input = e.target.closest('[data-boleta-rut-field]');
      if (!input) return;
      const form = input.closest('[data-boleta-rut-form]');
      const error = form?.querySelector('[data-boleta-rut-error]');
      const status = form?.querySelector('[data-boleta-rut-status]');
      if (error) error.hidden = true;
      if (status) status.textContent = '';
    });

    document.addEventListener('focusout', async (e) => {
      const input = e.target.closest('[data-boleta-rut-field]');
      if (!input) return;
      const form = input.closest('[data-boleta-rut-form]');
      if (!form) return;
      const error = form.querySelector('[data-boleta-rut-error]');
      const status = form.querySelector('[data-boleta-rut-status]');
      const value = input.value.trim();

      if (value !== '' && !isValidRut(value)) {
        if (error) error.hidden = false;
        return;
      }

      if (error) error.hidden = true;
      const normalized = value === '' ? '' : normalizeRut(value);
      input.value = normalized;
      try {
        await window.BenisCart.updateAttributes({ boleta_rut: normalized });
        if (status) status.textContent = value === '' ? '' : 'Guardado ✓';
      } catch (err) {
        console.error('Boleta RUT save error:', err);
        if (status) status.textContent = 'No se pudo guardar, inténtalo de nuevo.';
      }
    });
  }

  // ===== Código de descuento =====
  // snippets/cart-discount-form.liquid. Usa la Ajax API nativa de Shopify
  // (/cart/update.js con `discount`): Shopify valida el código y lo lleva
  // solo al checkout. `discount` REEMPLAZA la lista completa de códigos del
  // carrito, por eso siempre se parte de los que ya hay (/cart.js) — si no,
  // aplicar un código borraría p. ej. el canje de puntos de LoyaliU.
  // Mismo criterio de refresco que +/- de arriba: recargar la página, así
  // subtotal, descuentos, barra de envío gratis y total salen de Liquid.

  const DISCOUNT_FLASH_KEY = 'benis_discount_flash';

  function normalizeDiscountCode(code) {
    return (code || '').trim().toUpperCase();
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`cart.js ${res.status}`);
    return res.json();
  }

  async function setDiscountCodes(codes) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    });
    if (!res.ok) throw new Error(`cart/update.js ${res.status}`);
    return res.json();
  }

  function currentCodes(cart) {
    return (cart.discount_codes || []).map((d) => d.code).filter(Boolean);
  }

  function initCartDiscountForm() {
    const form = document.querySelector('[data-cart-discount-form]');
    if (!form || form.dataset.initialized === 'true') return;
    form.dataset.initialized = 'true';

    const input = form.querySelector('[data-cart-discount-input]');
    const applyBtn = form.querySelector('[data-cart-discount-apply]');
    const message = form.querySelector('[data-cart-discount-message]');

    function showMessage(text, isError) {
      message.textContent = text;
      message.classList.toggle('is-error', Boolean(isError));
      message.hidden = !text;
    }

    function flashAfterReload(text) {
      try {
        window.sessionStorage.setItem(DISCOUNT_FLASH_KEY, text);
      } catch (err) {
        // sin sessionStorage solo se pierde el mensaje, el código igual queda aplicado
      }
      window.location.reload();
    }

    try {
      const flash = window.sessionStorage.getItem(DISCOUNT_FLASH_KEY);
      if (flash) {
        window.sessionStorage.removeItem(DISCOUNT_FLASH_KEY);
        showMessage(flash, false);
      }
    } catch (err) {
      // ignore storage errors (private mode, etc.)
    }

    input.addEventListener('input', () => showMessage('', false));
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyBtn.click();
      }
    });

    applyBtn.addEventListener('click', async () => {
      const code = normalizeDiscountCode(input.value);
      if (!code) {
        showMessage('Ingresa un código.', true);
        input.focus();
        return;
      }

      applyBtn.disabled = true;
      const original = applyBtn.textContent;
      applyBtn.textContent = 'Aplicando…';
      showMessage('', false);

      try {
        const before = currentCodes(await fetchCart());
        if (before.some((c) => normalizeDiscountCode(c) === code)) {
          showMessage('Ese código ya está aplicado.', true);
          return;
        }

        const after = await setDiscountCodes([...before, code]);
        const applied = (after.discount_codes || []).find(
          (d) => normalizeDiscountCode(d.code) === code
        );

        if (applied && applied.applicable) {
          flashAfterReload(`Código ${code} aplicado ✓`);
          return;
        }

        // No aplicable: se deja el carrito exactamente como estaba.
        await setDiscountCodes(before);
        showMessage('Este código no es válido o no aplica a tu carrito.', true);
      } catch (err) {
        console.error('Cart discount apply error:', err);
        showMessage('No se pudo aplicar el código, inténtalo de nuevo.', true);
      } finally {
        applyBtn.disabled = false;
        applyBtn.textContent = original;
      }
    });

    form.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-discount-remove]');
      if (!btn) return;
      const code = normalizeDiscountCode(btn.dataset.cartDiscountRemove);

      btn.disabled = true;
      try {
        const remaining = currentCodes(await fetchCart()).filter(
          (c) => normalizeDiscountCode(c) !== code
        );
        await setDiscountCodes(remaining);
        flashAfterReload(`Código ${code} quitado.`);
      } catch (err) {
        console.error('Cart discount remove error:', err);
        showMessage('No se pudo quitar el código, inténtalo de nuevo.', true);
        btn.disabled = false;
      }
    });
  }

  function init() {
    initCartPageItems();
    initCartItemsScroll();
    initProductCarouselAtc();
    initProductCarouselDrag();
    initInvoiceForm();
    initBoletaRutForm();
    initCartDiscountForm();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
